import React, { FC, useCallback, useContext } from 'react';
import { NolPromotionStoreCtx } from '@/stores/NolPromotionStore';
import { observer } from 'mobx-react-lite';
import NolBottomSheet from '../NolBottomSheet';

const AlreadyHasCard: FC = () => {
  const store = useContext(NolPromotionStoreCtx);
  const onClick = useCallback(() => {
    store.isAlreadyHasCardBottomSheetOpen = false;
    store.isAlreadyHasCardBeforeRegisterBottomSheetOpen = false;
    store.onVersion3TabClick(0);
  }, []);

  return (
    <>
      <NolBottomSheet
        title={'NOL 카드 보유 안내'}
        isOpen={store.isAlreadyHasCardBeforeRegisterBottomSheetOpen}
        onRequestClose={() => (store.isAlreadyHasCardBeforeRegisterBottomSheetOpen = false)}
        body={{
          description:
            '현대카드에 전화로 NOL 카드 발급에 동의하셨습니다.\n실물 카드를 수령하신 후 NOL 카드 페이 및 NOL 쿠폰의 이용이 가능합니다.',
        }}
        button={{ label: '혜택 확인하기', onClick }}
      />
      <NolBottomSheet
        isOpen={store.isAlreadyHasCardBottomSheetOpen}
        onRequestClose={() => (store.isAlreadyHasCardBottomSheetOpen = false)}
        title={'NOL 카드 보유 안내'}
        body={{
          description: '이미 NOL 카드 발급 받았습니다.\n바로 누릴 수 있는 혜택을 확인해 보세요.',
        }}
        button={{ label: '혜택 확인하기', onClick }}
      />
    </>
  );
};

export default observer(AlreadyHasCard);
